import { connect } from "react-redux";
import { getBrandDisplayName } from "app/reducers/partnerSelector";
import AuthBookingLayer from "app/pages/Auth/AuthBookingLayer/AuthBookingLayer";

const mapStateToProps = state => {
	return {
		brandDisplayName: getBrandDisplayName(state),
	};
};

export default connect(mapStateToProps)(AuthBookingLayer);
